import { render, staticRenderFns } from "./CommissionsRatesPopup.vue?vue&type=template&id=311744c6&scoped=true&"
import script from "./CommissionsRatesPopup.vue?vue&type=script&lang=js&"
export * from "./CommissionsRatesPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311744c6",
  null
  
)

export default component.exports